const Config = {
  // baseURL: 'http://bd2266.com:5001/',
  // baseURL: 'http://1.rb88.space:5001/',
  // baseURL: 'http://localhost:5001/',
  baseURL: 'https://game.user.huijiekeji.net/api/',
  // baseURL: 'http://45.116.164.30:5001/',
  // 'http://bd5568.com:5001/',
  // baseURL: 'http://bd22255.com:5001/',
  // baseURL: 'http://jl2277.com:5001/',
  // baseURL: 'http://rb88.space:5001/', // baseURL: 'http://yhyl1234.com:5001/',
  // baseURL: 'http://45.116.167.147:5001', // baseURL: 'http://1.rb888.space:5001/',
  // baseURL: 'http://jl8588.com:5001/',
  stagnateTime: 1 * 60 * 60 * 1000, // 无操作停滞时间  默认1小时
  openAutoJumpOut: true, // 是否开启无操作跳出
  notLoginRoute: ['login'] // 无需登录即可访问的路由 name,
}

export default Config



// WEBPACK FOOTER //
// ./src/config/index.js